import { Button, Typography } from "@mui/material";
import CommonModal from "components/shared/common-modal/CommonModal";
import { t } from "i18next";

const PersonnelDetailRemoveCustomerAssociation = ({
  personnelDetailRemoveCustomerAssociationModalShow,
  setPersonnelDetailRemoveCustomerAssociationModalShow,
  onPersonnelDetailRemoveCustomerAssociation
}) => {
  return (
    <CommonModal
      open={personnelDetailRemoveCustomerAssociationModalShow}
      title={t("common.confirm")}
      body={
        <>
          <Typography>{t("personnelDetail.removeAssociationMsg1")}</Typography>
          <Typography>{t("personnelDetail.deleteMsgTwo")}</Typography>
        </>
      }
      buttons={
        <>
          <Button
            variant="outlined"
            onClick={() => onPersonnelDetailRemoveCustomerAssociation()}
          >
            {t("common.ok")}
          </Button>
          <Button
            variant="contained"
            onClick={() =>
              setPersonnelDetailRemoveCustomerAssociationModalShow(false)
            }
          >
            {t("common.cancel")}
          </Button>
        </>
      }
    />
  );
};

export default PersonnelDetailRemoveCustomerAssociation;
